import { render } from "./StoryMessage.vue?vue&type=template&id=38385caa"
import script from "./StoryMessage.vue?vue&type=script&lang=js"
export * from "./StoryMessage.vue?vue&type=script&lang=js"

import "./StoryMessage.vue?vue&type=style&index=0&id=38385caa&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__